import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33677c2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "side-bar" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (menuItem) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "list-item",
          key: menuItem.key
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['title-icon', _ctx.openName === menuItem.key ? 'active' : ''])
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(['title-icon2',_ctx.openName === menuItem.key ? 'active' : ''])
          }, null, 2),
          _createElementVNode("ul", {
            class: _normalizeClass(['list-content',_ctx.openName === menuItem.key ? menuItem.class : ''])
          }, [
            _createElementVNode("li", {
              class: "item title",
              onClick: ($event: any) => (_ctx.handleOpen(menuItem.key, menuItem.config))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["label title-label", _ctx.openName ===  menuItem.key ? 'active' : ''])
              }, _toDisplayString(menuItem.value), 3),
              _createElementVNode("i", {
                class: _normalizeClass(['whiteIcon','iconfont',menuItem.icon])
              }, null, 2)
            ], 8, _hoisted_3),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuConfig[menuItem.childrenIndex].clidren, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "item",
                key: item.type,
                onClick: ($event: any) => (_ctx.handleItemClick(item))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.activeItem === item.param ? 'item-active' : '')
                }, null, 2),
                _createElementVNode("span", {
                  class: "label",
                  innerHTML: item.label
                }, null, 8, _hoisted_5),
                _createElementVNode("span", {
                  class: _normalizeClass(["iconfont", [item.icon, _ctx.activeItem === item.param ? 'active' : '']])
                }, null, 2)
              ], 8, _hoisted_4))
            }), 128))
          ], 2)
        ]))
      }), 128))
    ])
  ]))
}